<div class="right_section_header" id="deviceCustomMain">
    <img class="header_icon main-tile-content-icon" alt="custom main tile content" />
    <span class="ml-2" i18n="@@device-popup-main-tile-content.title">CUSTOM MAIN TILE CONTENT</span>
</div>
<div class="mt-3" [ngClass]="(isCustomMainTileEmpty) ? 'existing_text_show': 'existing_text_hide'" id="noCustomMainTIle">
    <span i18n="@@devices.side-menu.no-main-tile-content-msg">There is no
        Custom Main Tile Content in the Asset Library</span>
</div>
<iposcen-spinner-overlay></iposcen-spinner-overlay>
<div class="right_section_body" id="customMainTItleLen">
    <strong> {{CustomMainTileLength}}
        <span i18n="@@device-main-tile-content.main-tile-content.name">Custom Main Tile Content Groups</span>
    </strong>

    <!-- Content groups - Accordion -->
    <div class="accordion" id="devicesMainTileAcc">
        <!-- Group 1 -->
        <iposcen-hero-tile [idFromMainContent]='idselected' (sendHeroLength)="getCustomMainTileLength($event)"
            (sendHeroTileData)="getCustomMainData($event)" [isDeviceMainTile]="true" [isNoneChecked]="noneChecked">
        </iposcen-hero-tile>
        <iposcen-spinner-overlay></iposcen-spinner-overlay>
    </div>
</div>

<!-- CTA Buttons -->
<div class="button_wrapper justify-content-end" id="ctaBtnWrapper">
    <button type="button" class="btn btn-outline-primary btn-lg" [disabled]='!noneSelected && !idselected' [innerHTML]="cancelChanges"
        (click)='cancel()'></button>
    <button type="button" class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent" [disabled]='!noneSelected && !idselected' [innerHTML]="saveChanges"
        (click)='sendDataToStore()'></button>
</div>

<div class="container" id="containerDiv">
    <div class="modal-dialog-centered" *ngIf="openModalPopup" id="deviceShutDownModal">
        <div class="modal-backdrop show" id="modalBackDropShow"></div>
        <div class="modal" id="myModal">
            <div class="modal-dialog" id="modalDialog">
                <div class="modal-content" id="modalContent">
                    <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="closeModal"><img _ngcontent-fjy-c198=""
                            alt="close" class="modal-close-icon"></div>
                    <div class="modal-body" id="modalBody">
                        <div class="text-center" *ngIf='!isCancel' id="textCenter">
                            <span class="success-img"></span>
                        </div>
                        <div class="action-success-msg" id="actionSuccessMsg" [ngClass]="isCancel ? 'text-left': 'text-center'">
                            <span>{{successMessage}}</span>
                        </div>
                        <div class="card_desc" id="cardDesc">
                            <span>{{description}}</span>
                        </div>
                    </div>
                    <div *ngIf='isCancel' class='modal-footer' id="modalFooterBtns">
                        <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
                        <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>